import type { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

interface StyleProps {
  placement?: 'topSideFilter' | string;
}

export default makeStyles((theme: Theme) => ({
  drawerWrapper: {
    padding: '12px 10px',
  },
  treeViewWrapper: {
    position: 'relative',
    '& .MuiTreeItem-content': {
      padding: '4px 0',
    },
    '& .MuiTreeItem-group': {
      marginLeft: '17px',
    },
    '& .MuiCollapse-root': {
      marginLeft: '17px',
    },
  },
  filterText: {
    fontSize: '16px',
    fontWeight: 500,
    margin: '0 0 6px 2px',
    letterSpacing: '0.5px',
    textTransform: 'uppercase' as const,
    color: theme.palette.text.secondary,
  },
  filterTextIcon: {
    display: 'flex',
  },
  categoryLabel: {
    fontSize: '14px',
    fontWeight: 400,
  },
  categoryIcon: {
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.text.secondary,
    '& .MuiSvgIcon-root': {
      fontSize: '20px',
    },
  },
  divider: {
    height: '1px',
    width: '100%',
    backgroundColor: theme.palette.divider,
    marginBottom: '8px',
  },
  categoryContainer: {
    marginBottom: '2px',
    borderRadius: '6px',
    transition: 'background-color 0.15s ease',
  },
  categoryHeader: {
    cursor: 'pointer',
    background: 'none',
    border: 'none',
    font: 'inherit',
    color: 'inherit',
    width: '100%',
    textAlign: 'left' as const,
    padding: '7px 8px',
    borderRadius: '6px',
    transition: 'background-color 0.15s ease',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.06)',
    },
  },
  facetsList: {
    marginLeft: '12px',
    padding: '4px 8px 8px 16px',
    borderLeft: `2px solid ${theme.palette.divider}`,
    marginBottom: '4px',
  },
  choiceItem: {
    display: 'flex',
    alignItems: 'center',
    borderRadius: '4px',
    transition: 'background-color 0.1s ease',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.04)',
    },
  },
  treeItemWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
  },
  treeIcon: {
    position: 'relative',
    top: '2px',
  },
  treeItemCheckbox: {
    padding: '3px',
  },
  treeItemLabel: {
    fontSize: '12px',
    marginLeft: '2px',
    opacity: 0.7,
  },
  filterCountBadge: {
    marginLeft: 'auto',
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.secondary.contrastText || '#fff',
    borderRadius: '10px',
    padding: '0 7px',
    fontSize: '11px',
    fontWeight: 600,
    lineHeight: '18px',
    minWidth: '18px',
    textAlign: 'center' as const,
  },
  clearFiltersButton: (props: StyleProps) => ({
    display: 'flex',
    marginTop: props.placement === 'topSideFilter' ? 15 : 12,
    fontSize: 12,
    color: theme.palette.secondary.main,
    textTransform: 'uppercase' as const,
    letterSpacing: '0.5px',
  }),
  customLabel: {},
}));
